export default __webpack_public_path__ + "media/images/home/slide_go_lg-57d82e33a5dcbc8ba95f928f96c3d298.jpg";